
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/996388af2a2c408cf3ec99d47234a378/31a8f353fecb75fc1f2431fc02e10c33.png"
                alt="Elegance Staffing"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Creating memorable experiences with professional service and attention to detail since 2015.
            </p>
          </div>

          <div>
            <h4 className="text-[#D4AF37] font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Home</a>
              </li>
              <li>
                <a href="#about-us" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">About Us</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Services</a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-[#D4AF37] transition-colors cursor-pointer">Gallery</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#D4AF37] font-bold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Professional Waiters</li>
              <li className="text-gray-400">Premium Catering</li>
              <li className="text-gray-400">Event Decoration</li>
              <li className="text-gray-400">Corporate Events</li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#D4AF37] font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 flex items-start gap-2">
                <i className="ri-map-pin-line text-[#D4AF37] mt-1"></i>
                <span>Dallas, Texas</span>
              </li>
              <li className="text-gray-400 flex items-start gap-2">
                <i className="ri-phone-line text-[#D4AF37] mt-1"></i>
                <a href="tel:+14699249598" className="hover:text-[#D4AF37] transition-colors">+1 (469) 924 9598</a>
              </li>
              <li className="text-gray-400 flex items-start gap-2">
                <i className="ri-mail-line text-[#D4AF37] mt-1"></i>
                <a href="mailto:info@elegancestaffing.com" className="hover:text-[#D4AF37] transition-colors">info@elegancestaffing.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Elegance Staffing. All rights reserved.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-[#D4AF37] rounded-full flex items-center justify-center transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#D4AF37] text-sm transition-colors">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
